import { getToday, addDays } from 'ha/helpers/hadate';
import { FilterBuilder } from '../Types';

const creationDateTSBuilder: FilterBuilder = params => {
  const recentlyAdded = params.recentlyAdded;

  if (!recentlyAdded) {
    return '';
  }

  const daysBack = {
    '1-day': 1,
    '3-days': 3,
    '7-days': 7,
    '14-days': 14,
  }[recentlyAdded];

  const creationDate = addDays(getToday(), -daysBack);
  const creationDateTS = new Date(creationDate).getTime() / 1000;

  return `creationDateTS>=${creationDateTS}`;
};

export default creationDateTSBuilder;
